<template>
  <button
    :class="btnClass"
    @click="onBtnClick"
    v-bind="$attrs"
    :aria-label="ariaLabel"
    tabindex="0"
  >
    <slot name="button-icon"></slot>
    <span v-if="btnText" v-text="btnText" />
  </button>
</template>
<script>
import { DEButtonMixins } from '../Mixins';

export default {
  name: 'DEButton',
  mixins: [DEButtonMixins],
  computed: {
    btnClass() {
      let classes = {
        'common-btn': true,
      };

      classes[`text-${this.btnTextVariant}`] = !!this.btnTextVariant;
      classes[`text-${this.btnTextVariantHover}-hover`] =
        !!this.btnTextVariantHover;
      classes[`bg-${this.btnVariant}`] = !!this.btnVariant;
      classes[`bg-${this.btnVariantHover}-hover`] = !!this.btnVariantHover;
      classes[`outline-${this.btnOutlineColor}`] = !!this.btnOutlineColor;

      if (this.btnVariantDisabled) {
        classes[`bg-${this.btnVariantDisabled}-disable`] =
          !!this.btnVariantDisabled;
      }

      return classes;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '../Styles/de_button.styl';
</style>
